import React from 'react';

const HeroBanner = () => {
  return (
    <section className="relative w-[78%] sm:max-w-7xl sm:w-full mx-auto h-[531px] sm:h-[356px] md:h-[428px] lg:h-[481px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_d5833d15-1b98-40ab-ba72-62fc5cc0e631/artifacts/11hboz6d_New-steel-framing-house-.jpg"
          alt="Steel Roll Forming Machines in Factory"
          className="w-full h-full object-cover sm:object-[center_10%] object-[center_55%]"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/30 via-slate-900/50 to-slate-900/70"></div>
      </div>

      {/* Content Overlay */}
      <div className="relative z-10 h-full flex flex-col items-center px-6 md:px-12">
        {/* Text Content - Centered in upper area */}
        <div className="flex-1 flex flex-col justify-center items-center pt-28 sm:pt-14">
          <h2
            className="text-4xl md:text-6xl font-bold tracking-tight uppercase text-white text-center mb-0 leading-none"
            style={{ fontFamily: 'Rajdhani, sans-serif' }}
          >
            The Next Generation Of
          </h2>
          <p className="text-2xl md:text-3xl text-white text-center mb-1 uppercase tracking-wider font-bold"
            style={{ fontFamily: 'Rajdhani, sans-serif' }}
          >
            Steel Roll Forming Technology
          </p>
          <p className="text-xl md:text-2xl text-[#c4d82e] text-center mb-0 mt-3 uppercase tracking-wide font-semibold"
            style={{ fontFamily: 'Rajdhani, sans-serif' }}
          >
            Try 3D Metal Home Building, And You Will Never Use Wood Again
          </p>
        </div>

        {/* Stats Grid - At bottom */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-1.5 md:gap-3 max-w-md md:max-w-2xl w-full mb-2">
          <div className="bg-slate-900/50 backdrop-blur-sm p-1.5 md:p-4 text-center">
            <div className="text-base md:text-2xl font-bold text-[#c4d82e] mb-0" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
              1 Day
            </div>
            <div className="text-[9px] md:text-sm text-white uppercase tracking-wider">
              Full Frame Printing
            </div>
          </div>

          <div className="bg-slate-900/50 backdrop-blur-sm p-1.5 md:p-4 text-center">
            <div className="text-base md:text-2xl font-bold text-[#c4d82e] mb-0" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
              2-3 Days
            </div>
            <div className="text-[9px] md:text-sm text-white uppercase tracking-wider">
              On-Site Assembly
            </div>
          </div>

          <div className="bg-slate-900/50 backdrop-blur-sm p-1.5 md:p-4 text-center">
            <div className="text-base md:text-2xl font-bold text-[#c4d82e] mb-0" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
              20-40%
            </div>
            <div className="text-[9px] md:text-sm text-white uppercase tracking-wider">
              Typical Insurance Savings
            </div>
          </div>

          <div className="bg-slate-900/50 backdrop-blur-sm p-1.5 md:p-4 text-center">
            <div className="text-base md:text-2xl font-bold text-[#c4d82e] mb-0" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
              0% Waste
            </div>
            <div className="text-[9px] md:text-sm text-white uppercase tracking-wider">
              Pre-Engineered Panels
            </div>
          </div>
        </div>

        <div className="mb-4 text-center">
          <p className="text-xs text-white flex items-center justify-center">
            <span className="text-[#c4d82e] text-base mr-2">★</span>
            Delivered to your site in 2 days from order in most cases
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
